'use client'

	import React from 'react'
import { useTheme } from "@mui/material"
import { StyledList } from './list.styles';

export function List({ children, indent=2, component="ul", ...props }) {
  const theme = useTheme();

  return (
    <StyledList ml={indent} pl={0} width={`calc(100% - ${theme.spacing(indent)})`} component={component} boxSizing="border-box" {...props}>
      {children}
    </StyledList>
  )
}

export default List